import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Transfers',
		url: '/transfers',
		icon: 'random',
	},
];

export default class Transfers extends Framework.Components.View {

	handleSetTotal = (totalCount) => {
		this.setState({totalCount});
	}

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar
					breadcrumbs={breadcrumbsStatic}
					history={this.props.history}
				>
					<div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
						{this.state.totalCount > 0 && (
							<div style={{
								position: 'absolute',
								right: '50%',
								transform: 'translateX(50%)',
								color: '#666',
								fontSize: '0.9em',
								fontWeight: '500',
								pointerEvents: 'none'
							}}>
								{this.state.totalCount + " total firearms"}
							</div>
						)}
					<Button onClick={this.toggle('modalTransfer')} size="sm" color="primary">
						<i className="fa fa-random"/>&nbsp;&nbsp;Add Transfer
					</Button>
					</div>
				</Framework.Components.PageBar>

				<Collections.Transfers
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					scannedCode={!this.state['modalTransfer'] ? this.props.scannedCode : null}
					showDateRangeSearch={true}
					setTotalCount={this.handleSetTotal}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name={"Transfer"}
					object={Objects.Transfer}
					history={this.props.history}
					toggle={this.state['modalTransfer']}
					reportClose={this.reportClose('modalTransfer')}
					afterSave={() => {
						this.handleAfterSave()
						this.props.history.push('/');
						this.props.history.push('/transfers');
					}}
					objectProps={{scannedCode: this.state['modalTransfer'] ? this.props.scannedCode : null}}
				/>

			</div>
		);
	}
}

